var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"btn",class:_vm.btnClass},'button',_vm.$attrs,false),_vm.$listeners),[(_vm.$attrs.loading)?[_c('van-loading',{attrs:{"size":"20px"}}),_vm._v(" "+_vm._s(_vm.loadingText)+"\n  ")]:_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }